import React, { Component } from "react";
import {
  AssessTestPreview,
  AssessTestTake,
  AssessSelectorBar,
  AssessNotFound
} from "../Assessment";
import { AssessTestOverview, AssessTestResults } from "./AssessTest";
import has from "mout/object/has";
import { Row, Card, CardBody, Alert, Col } from "reactstrap";
import { BeatLoader } from "react-spinners";
import getBaseQuery from "../../helpers/assessment/getBaseQuery";
import {find} from 'lodash'
const queryString = require("query-string");

/* AssessmentTestingContainer
      <AssessmentTesting
        userAssessment={this.props.userAssessment}
        routeParams={this.props.match.params}
        inTest={this.props.inTest}
        search={this.props.location.search}
        setInTest={this.props.setInTest}
        activeItem={this.props.activeItem}
        selectAnswer={this.props.setSelectedAnswer}
        selectedAnswer={this.props.selectedAnswer}
        handleSubmitActivity={this.handleSubmitActivity}
        handleSubmitSubtest={this.handleSubmitSubtest}
        handleQuickNav={this.handleQuickNav}
        openTest={this.openTest}
        groupUAs={this.props.groupUAs}
        selectedGroupUA={selectedGroupUA}
        groupUA={groupUA}
        user={testUser}
        assessmentId={assessmentId}
        subtestId={subtestId}
        items={this.props.items}
        nodes={this.props.nodes}
        passages={this.props.passages}
      />

*/

class AssessmentTesting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null
    };
  }

  /*

    Major views:
      Intro
      Taking Test
      Overview Navigation and Final confirmation
      Results Summary


    if !inTest && !completed: <AssessTestPreview />
    if completed (and query right): <AssessTestResultsSummary />
    if inTest && !completed (set query right if wrong): <AssessTestTake />
    if !completed (and query to an item): <AssessTestTake /> (but can't answer question, shows explanation)
    if inTest && !completed (and query to overview): <AssessTestOverview />



  */
  getNodeFilter(query) {
    let nodeFilter = "";
    if (query && query.nd) {
      nodeFilter = query.nd;
    }
    return nodeFilter;
  }

  componentDidMount() {}

  componentWillReceiveProps() {
    let search = "";
    if (this.props.search) {
      search = queryString.parse(this.props.search).item;
    }
    if (search === "overview") {
      const query = queryString.parse(this.props.search);
      let nodeFilter = this.getNodeFilter(query);
      let selectedValue = null;
      if (nodeFilter !== "") {
        const nodeName = this.props.nodes[nodeFilter].name;
        selectedValue = {
          value: nodeFilter,
          label: nodeName
        };
        this.setState({ selectedOption: selectedValue });
      } else {
        this.setState({ selectedOption: null });
      }
    }
  }

  render() {
    const { loadingError, updatingGUA,state } = this.props;
    let comp = (
      <div>
        {this.props.userAssessment && this.props.previousTest && (
          <AssessTestPreview
            userAssessment={this.props.userAssessment}
            routeParams={this.props.routeParams}
            search={this.props.search}
            setInTest={this.props.setInTest}
            openTest={this.props.openTest}
          />
        )}
        {!this.props.userAssessment && (
          <Card>
            <CardBody>
              <BeatLoader loading={true} />
            </CardBody>
          </Card>
        )}
      </div>
    );

    // if it's a student, nav to test if incomplete
    let search = "";
    let is_completed = true;
    if (this.props.search) {
      search = queryString.parse(this.props.search).item;
    }
    if (search === "overview") {
      const query = queryString.parse(this.props.search);
      const { subtestId } = this.props;
      if (
        this.props.userAssessment &&
        (!this.props.userAssessment.destructuredSubtests[subtestId] ||
          !this.props.userAssessment.destructuredSubtests[subtestId]
            .complete) &&
        this.props.user.role === "Student"
      ) {
        const { routeParams, history } = this.props;
        const { userAssessmentId, subTestSetId } = routeParams;
        // history.replace(`/assessment/testing/${userAssessmentId}/${subTestSetId}`)
        is_completed = false;
      
        
      }
      
      comp = (
        <AssessTestOverview
          userAssessment={this.props.userAssessment}
          userAssessmentCompare={this.props.userAssessmentCompare}
          currentAssessmentId = {this.props.currentAssessmentId}
          compareAssessmentId = {this.props.compareAssessmentId}
          routeParams={this.props.routeParams}
          search={this.props.search}
          handleSubmitSubtest={this.props.handleSubmitSubtest}
          groupUAs={this.props.groupUAs}
          selectedGroupUA={this.props.selectedGroupUA}
          groupUA={this.props.groupUA}
          groupUACompare = {this.props.groupUACompare}
          user={this.props.user}
          assessmentId={this.props.assessmentId}
          subtestId={this.props.subtestId}
          items={this.props.items}
          nodes={this.props.nodes}
          passages={this.props.passages}
          groupData={this.props.groupData}
          selectGroupUA={this.props.selectGroupUA}
          selectStudent={this.props.selectStudent}
          selectedStudent={this.props.selectedStudent}
          query={query}
          selectedOption={this.state.selectedOption}
          navTo={this.props.navTo}
          isFetchingGroupUAs={this.props.isFetchingGroupUAs}
          aFetchingAllItems={this.props.aFetchingAllItems}
          aFetchingAllPassages={this.props.aFetchingAllPassages}
          is_completed={is_completed}
          year={this.props.year}
          updatingGUA={updatingGUA}
          isCompare = {this.props.isCompare}
          test1 = {this.props.test1}
          test2 = {this.props.test2}
          isSwap = {this.props.isSwap}
          
        />
      );
    }
    if (search === "results") {
      comp = (
        <AssessTestResults
          userAssessment={this.props.userAssessment}
          routeParams={this.props.routeParams}
          search={this.props.search}
        />
      );
    }

    const subTestId = this.props.routeParams.subTestSetId;
    if (this.props.userAssessment && !this.props.isGroup) {
      if (
        (this.props.inTest ||
          (this.props.userAssessment.destructuredSubtests[subTestId] &&
            this.props.userAssessment.destructuredSubtests[subTestId]
              .complete)) &&
        !this.props.userAssessment.completed &&
        search !== "overview" &&
        search !== "results"
      ) {
        const itemNumber = queryString.parse(this.props.search).item;

        let selectedAnswer = "";
        const userAssessment = this.props.userAssessment;
        let activeItemId = "";
        if (this.props.activeItem) {
          activeItemId = this.props.activeItem.itemId;
        }
       
        if (activeItemId && has(userAssessment, `answersByItem.${subTestId}`)) {
          selectedAnswer =
            userAssessment.answersByItem[subTestId][activeItemId];
        }
        let subtestName = "";
        if (
          has(this.props, "userAssessment.assessmentSubtests") &&
          this.props.subtestId
        ) {
          if (
            this.props.userAssessment.assessmentSubtests[this.props.subtestId]
          )
            subtestName = this.props.userAssessment.assessmentSubtests[
              this.props.subtestId
            ].displayName;
        }
        comp = (
          <AssessTestTake
            userAssessment={this.props.userAssessment}
            routeParams={this.props.routeParams}
            search={this.props.search}
            setInTest={this.props.setInTest}
            activeItem={this.props.activeItem}
            selectAnswer={this.props.handleSubmitActivity}
            selectedAnswer={selectedAnswer}
            itemNumber={itemNumber}
            handleSubmitActivity={this.props.handleSubmitActivity}
            handleQuickNav={this.props.handleQuickNav}
            user={this.props.user}
            subtestName={subtestName}
            subtestId={this.props.subtestId}
            items={this.props.items}
            navTo={this.props.navTo}
            handleSubmitSubtest={this.props.handleSubmitSubtest}
            toggleAnswerExpired={this.props.toggleAnswerExpired}
            answerSelectedExpired={this.props.answerSelectedExpired}
            licenseExpired={this.props.licenseExpired}
          />
        );
      }
    } else if (
      /*this.props.selectedGroupUA && this.props.groupUAs && this.props.groupUA*/ this
        .props.isGroup
    ) {
      if (search !== "overview" && search !== "results") {
        const itemNumber = queryString.parse(this.props.search).item;

        let assessSelectorBar = null;

        const groupDataCheck =
          !!this.props.groupData.districts &&
          !!this.props.groupData.schools &&
          !!this.props.groupData.schools &&
          !!this.props.groupData.educators &&
          !!this.props.groupData.students;
        const selectHeaderStye = {
          display: "flex",
          flexWrap: "wrap",
          marginTop: "-21px"
        };
        if (this.props.user.role !== "Student" && groupDataCheck) {
          assessSelectorBar = (
            <div style={selectHeaderStye}>
              <AssessSelectorBar
                selectedGroupUA={this.props.selectedGroupUA}
                groupUAs={this.props.groupUAs}
                groupData={this.props.groupData}
                assessmentId={this.props.assessmentId}
                role={this.props.user.role}
                selectGroupUA={this.props.selectGroupUA}
                selectStudent={this.props.selectStudent}
                selectedStudent={this.props.selectedStudent}
                itemNumber={itemNumber}
                updatingGUA={updatingGUA}
                year={this.props.year}
              />
            </div>
          );
        }

        let selectedAnswer = "";
        let inputUA = this.props.groupUA;
        let subtestName = "";
        if (this.props.selectedStudent && this.props.userAssessment) {
          inputUA = this.props.userAssessment;
          const userAssessment = this.props.userAssessment;
          let activeItemId = "";
          if (this.props.activeItem) {
            activeItemId = this.props.activeItem.itemId;
          }
          if (
            activeItemId &&
            has(userAssessment, `answersByItem.${subTestId}`)
          ) {
            selectedAnswer =
              userAssessment.answersByItem[subTestId][activeItemId];
          }
        }
        if (this.props.userAssessment) {
          if (
            has(this.props, "userAssessment.assessmentSubtests") &&
            this.props.subtestId
          ) {
            if (
              this.props.userAssessment.assessmentSubtests[this.props.subtestId]
            )
              subtestName = this.props.userAssessment.assessmentSubtests[
                this.props.subtestId
              ].displayName;
          }
        } else if (this.props.groupUA) {
          if (
            has(this.props, "groupUA.assessmentSubtests") &&
            this.props.subtestId
          ) {
            if (this.props.groupUA.assessmentSubtests[this.props.subtestId])
              subtestName = this.props.groupUA.assessmentSubtests[
                this.props.subtestId
              ].displayName;
          }
        }

        comp = (
          <div>
            {assessSelectorBar}
            <AssessTestTake
              userAssessment={inputUA}
              routeParams={this.props.routeParams}
              search={this.props.search}
              setInTest={this.props.setInTest}
              activeItem={this.props.activeItem}
              selectAnswer={this.props.handleSubmitActivity}
              selectedAnswer={this.props.selectedStudent ? selectedAnswer : ""}
              itemNumber={itemNumber}
              handleSubmitActivity={this.props.handleSubmitActivity}
              handleQuickNav={this.props.handleQuickNav}
              isGroup={true}
              assessmentId={this.props.assessmentId}
              selectedStudent={this.props.selectedStudent}
              groupUA={this.props.groupUA}
              subtestId={this.props.subtestId}
              user={this.props.user}
              subtestName={subtestName}
              items={this.props.items}
              selectedGroupUA={this.props.selectedGroupUA}
              handleSubmitSubtest={this.props.handleSubmitSubtest}
              navTo={this.props.navTo}
              answerSelectedExpired={this.props.answerSelectedExpired}
              licenseExpired={this.props.licenseExpired}
            />
          </div>
        );
      }
    }
    if (
      search &&
      search !== "results" &&
      search !== "overview" &&
      isNaN(search)
    ) {
      return <AssessNotFound />;
    }

    return (
      <div>
        {loadingError && (
          <Alert style={{marginBottom: "40px"}}>
          Error loading. Check your internet connection and try again.
        </Alert>
        )}
          {/* {(licenseMessage) && (
           <Col><Alert color="danger">
              Your license has expired.
            </Alert>
            </Col>
          )} */}
        {comp}
      </div>
    );
  }
}

export default AssessmentTesting;


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessmentTesting.js